export const SEND_RECOMMEND_OFFICE_EMAIL = 'SEND_RECOMMEND_OFFICE_EMAIL';
export const SEND_RECOMMEND_OFFICE_EMAIL_DONE = 'SEND_RECOMMEND_OFFICE_EMAIL_DONE';



// WEBPACK FOOTER //
// ./app/constants/recommendOfficeType.js